<template>
    <div class="form__group">

        <TreeSelect
            ref="select"
            v-model="value"
            :options="items"
            placeholder="Select..."
            :multiple="treeSelectOptions.multiple"
            :searchable="treeSelectOptions.searchable"
            :flat="treeSelectOptions.flat"
            :async="treeSelectOptions.async"
            :autoDeselectAncestors="treeSelectOptions.autoDeselectAncestors"
            :autoDeselectDescendants="treeSelectOptions.autoDeselectDescendants"
            :autoSelectAncestors="treeSelectOptions.autoSelectAncestors"
            :autoSelectDescendants="treeSelectOptions.autoSelectDescendants"
            :flattenSearchResults="treeSelectOptions.flattenSearchResults"
            :auto-load-root-options="treeSelectOptions.autoLoadRootOptions"
            :flatten-search-results="treeSelectOptions.flattenSearchResults"
            :open-direction="treeSelectOptions.openDirection"
            :default-options="treeSelectOptions.defaultOptions"
            :load-options="loadOptions"
        />
        <label class="form__label">{{ label }}</label>
        <div class="form__validation" slot="validation">{{ errors.first(this.name) }}</div>
    </div>
</template>
<script>
    import TreeSelect from '@proj-lib/vue2-treeselect/vue-treeselect.cjs';
    import merge from 'lodash.merge';
    import unionBy from 'lodash.unionby';
    import API from '@api';

    export default {
        inject: {
            $validator: '$validator'
        },
        $_veeValidate: {
            value() {
                return this.value;
            },
            name() {
                return this.name;
            },
        },
        name: 'FormControlDynamicSector',
        components: {
            TreeSelect
        },
        props: {
            defaultValue: {},
            name: {
                type: String,
                required: true,
            },
            label: {
                type: String,
                default: 'Sector',
            },
            parentSectorId: {
                type: Number,
                default: null,
            },
            includeParentSector: {
                type: Boolean,
                default: true,
            },
            options: {
                type: Object,
                default: () => ({})
            },
            defaultItems: {
                type: Array,
                default: () => ([])
            }
        },
        data: function() {
            const treeSelectOptions = merge(
                {},
                {
                    multiple: true,
                    searchable: true,
                    flat: true,
                    autoDeselectAncestors: false,
                    autoDeselectDescendants: true,
                    autoSelectAncestors: true,
                    autoSelectDescendants: false,
                    flattenSearchResults: true,
                    autoLoadRootOptions: false,
                    async: true,
                    defaultOptions: true,
                    openDirection: 'auto',
                },
                this.options
            );

            return {
                value: this.defaultValue ?? null,
                items: this.defaultItems ?? null,
                treeSelectOptions: treeSelectOptions,
            }
        },
        methods: {
            async loadOptions({ action, parentNode, callback, searchQuery, ...rest }) {
                switch(action) {
                    case 'ASYNC_SEARCH' : {
                        let items = await API.getSectors({
                            top_level: !(!!this.parentSectorId),
                            hierarchical: false,
                            parent_id: this.parentSectorId ?? null,
                            include_parent: this.includeParentSector ?? true,
                            is_dropdown: true,
                            query: searchQuery ?? null
                        });

                        items = (items ?? []).map((item) => {
                            const foundNode = Object.values(this.$refs.select.forest.nodeMap).find((node) => node.id === item.id);

                            if(foundNode){
                                return merge({}, item, { children: foundNode.children });
                            }

                            return item;
                        })

                        callback(null, items);
                        break;
                    }
                    case "LOAD_ROOT_OPTIONS": {
                        const data = await API.getSectors({
                            top_level: !(!!this.parentSectorId),
                            hierarchical: false,
                            parent_id: this.parentSectorId ?? null,
                            include_parent : false,
                            is_dropdown: true,
                        });

                        this.items = unionBy([], this.items, data, 'id');

                        callback();
                        break;
                    }
                    case 'LOAD_CHILDREN_OPTIONS': {
                        const data = await API.getSectors({
                            hierarchical: false,
                            parent_id: parentNode.id,
                            is_dropdown: true,
                            include_parent : false,
                        });

                        parentNode.children = unionBy([], parentNode.children, data, 'id');
                        parentNode.isLoaded = false;

                        callback();
                        break;
                    }
                }
            },
            clear() {
                this.value = [];
            }
        },
        mounted() {
            this.treeSelectOptions = merge({}, this.treeSelectOptions, this.options);
        },
        watch: {
            items: function() {
                console.log("items have changed");
                if(this.items.length > 0) {
                    this.value = this.defaultValue;
                }
            },
            value: function() {
                this.$emit("input", this.value);
            }
        },

    }
</script>
